export const applicationTitles = {
    admin:             'Admin',
    architect:         'Architect',
    dashboard:         'Dashboard',
    devPortal:         'API Docs',
    home:              'Home',
    iotHub:            'IoT Hub',
    myAccount:         'My Account',
    reporting:         'Reporting',
    ruleBuilder:       'Rule Builder',
    serviceManagement: 'Service Requests',
    subscriptions:     'Subscriptions'
};
